import PATH from "constants/path";
import React from "react";
import FormContact from "features/Contact/components/FormContact";
import FormContactAuth from "features/Contact/components/FormContactAuth";
import { useDispatch, useSelector } from "react-redux";
import { saveContact } from "features/Contact/contactSlice";
import { useHistory } from "react-router";
import { useForm } from "react-hook-form";
import { isAuthenticated } from "utils/common";
import { getCMS } from "features/Contact/contactSlice";
import { useEffect } from "react";

function SubmitContact() {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
    clearErrors,
    setError,
  } = useForm();

  const { info, isInLine } = useSelector((state) => state.contact);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getCMS());
  }, []);

  const onSubmit = (data) => {
    if (
      (data.type == 1 && isAuthenticated()) ||
      (data.type == 0 && !isAuthenticated())
    ) {
      dispatch(saveContact(data));
      history.push(PATH.CONTACT_CONFIRM);
    } else {
      window.location.reload();
    }
  };

  const onError = (errors, e) => {
    let type = e.target.type.value;
    if (
      errors &&
      !((type == 1 && isAuthenticated()) || (type == 0 && !isAuthenticated()))
    ) {
      window.location.reload();
    }
  };

  return (
    <div className={isAuthenticated() ? "w-80 py-0 py-md-3" : "container px-0"}>
      <div className="px-3 px-lg-0">
        <div className="fs-18 fs-sm-16 fw-600 text-center my-3 my-md-4">
          お問い合わせ
        </div>
        
        {
          !isInLine &&
            <div className="text-md-center mb-3 fw-600">
              下記の項目をご入力の上、「個人情報の取扱いに同意する」にチェックを入れてお進みください。
            </div>
        }
      </div>

      {isAuthenticated() ? (
        <FormContactAuth
          register={register}
          user={user}
          info={info}
          onSubmit={onSubmit}
          onError={onError}
          errors={errors}
          handleSubmit={handleSubmit}
        />
      ) : (
        <FormContact
          register={register}
          info={info}
          onSubmit={onSubmit}
          onError={onError}
          errors={errors}
          handleSubmit={handleSubmit}
          watch={watch}
          clearErrors={clearErrors}
          setError={setError}
        />
      )}

      {
        isInLine &&
          <div className="text-md-center mb-2">
            <p>現在表示できません。しばらく経ってから再度お試しください。</p>
            <p>お急ぎの場合は以下のお電話または問い合わせフォームからお問い合わせください。</p>
          </div>
      }

      <div className="border-color-grey-light bg-f4 rounded-3 py-2 px-2 px-lg-0 mx-3 mx-lg-0 mb-2">
        <div className="w-50 mx-auto text-center">
          <div className="fw-600">【番組観覧】</div>
          <div className="my-2">
            <h3 className="fs-600">03-4213-7700</h3>
          </div>
          <div className="fw-600">【番組参加】</div>
          <div className="my-2">
            <h3 className="fs-600">03-4213-7701</h3>
            <div className="fs-12 lh-21">
              受付時間／12:00～19:00(土曜・日曜・祝日を除く)
            </div>
          </div>
          <div className="text-start ms-md-5 fs-12">
            ※オペレーターがご案内します。
            <br />
            ※通話料金はお客様のご負担となります。ご了承ください。
          </div>
        </div>
      </div>

      {
        isInLine &&
          <div className="border-color-grey-light bg-f4 py-2 px-2 px-lg-0 mx-3 mx-lg-0 w-712 rounded-3 text-center">
              <p className="fw-600">問い合わせフォームでのお問い合わせ</p>
              <p className="my-2 fs-12">以下のお問い合わせフォームURLからお問い合わせください。</p>
              <p className="my-2 fs-12"><a href="https://info.architect-monitor.jp/contact">https://info.architect-monitor.jp/contact</a></p>
          </div>
      }
    </div>
  );
}

export default SubmitContact;
